import {
  HttpResponse,
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpStatusCode,
} from '@angular/common/http';
import { tap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { inject, Injector } from '@angular/core';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem('token');
  const injector = inject(Injector);

  let authReq = req;
  if (token) {
    authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  return next(authReq).pipe(
    tap({
      error: (error: HttpErrorResponse) => {
        console.error('Error:', error);
        if (error.status === HttpStatusCode.Unauthorized) {
          const authService = injector.get(AuthService);
          authService.logout();
        }
        return throwError(() => error);
      },
    })
  );
};
